import * as React from 'react';

import type {WidgetFragment as Widget, LeadStagesEdge} from 'nutshell-graphql-types';

import {CollapsibleCardWidget} from '../../../core/card/collapsible-card-widget';

import {GoalSection} from './goal-section';
import {StageSelector} from './stage-selector';
import {StageTaskSection} from './stage-task-section';

type Props = {
    leadId: string;
    widget: Widget;
    currentStageId: string;
    leadStageEdges: LeadStagesEdge[];
};

export function SalesProcessWidget(props: Props) {
    const [selectedStageId, setSelectedStageId] = React.useState<string>(props.currentStageId);

    // Update our selected stage whenever the lead moves stages
    React.useEffect(() => {
        setSelectedStageId(props.currentStageId);
    }, [props.currentStageId]);

    const stageSelector = React.useMemo(() => {
        return (
            <StageSelector
                leadStageEdges={props.leadStageEdges}
                activeStageId={props.currentStageId}
                selectedStageId={selectedStageId}
                onStageChange={setSelectedStageId}
            />
        );
    }, [props.leadStageEdges, props.currentStageId, selectedStageId, setSelectedStageId]);

    return (
        <CollapsibleCardWidget
            widget={props.widget}
            secondaryTitle={!props.widget.isCollapsedForUser && stageSelector}
        >
            <GoalSection leadId={props.leadId} selectedStageId={selectedStageId} />
            <StageTaskSection leadId={props.leadId} selectedStageId={selectedStageId} />
        </CollapsibleCardWidget>
    );
}
